import LookupAppSystemsRequestModelBase from '../_generated/modelBases/lookup-app-systems-request-model-base';

export default class LookupAppSystemsRequestModel extends LookupAppSystemsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
